import { MapPin, Navigation, Phone, Clock3 } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";

export function LocationSection({ settings }) {
  const q = encodeURIComponent(settings?.maps_query || "Red Stone Ceccano");
  return (
    <section id="dove-siamo" className="py-24 sm:py-32 bg-slate2 border-y border-white/5" data-testid="location-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Eyebrow>Dove Siamo</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <SectionTitle className="mt-4">
            Vieni a <em className="italic text-gold-glow">trovarci</em>
          </SectionTitle>
        </Reveal>

        <div className="mt-12 grid lg:grid-cols-5 gap-8 items-stretch">
          <Reveal delay={0.15} className="lg:col-span-3">
            <div className="relative h-full min-h-[320px] rounded-2xl overflow-hidden border border-white/10">
              <iframe
                title="Mappa Red Stone Ceccano"
                data-testid="location-map-frame"
                src={`https://www.google.com/maps?q=${q}&output=embed`}
                className="absolute inset-0 w-full h-full grayscale-[35%] contrast-[1.05]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </Reveal>

          <Reveal delay={0.25} className="lg:col-span-2">
            <div className="h-full bg-card2 border border-white/10 rounded-2xl p-7 sm:p-9 flex flex-col">
              <div className="flex items-start gap-4">
                <MapPin className="w-5 h-5 text-burgundy-glow mt-1 shrink-0" />
                <div>
                  <p className="font-serif text-xl text-cream">{settings?.address}</p>
                  <p className="text-sm text-cream-muted mt-0.5">{settings?.city}</p>
                </div>
              </div>

              {settings?.hours?.length > 0 && (
                <div className="mt-7 flex items-start gap-4">
                  <Clock3 className="w-5 h-5 text-burgundy-glow mt-1 shrink-0" />
                  <ul className="space-y-1.5">
                    {settings.hours.map((h, i) => (
                      <li key={i} className="text-sm text-cream-muted">{h}</li>
                    ))}
                  </ul>
                </div>
              )}

              {settings?.notice && (
                <p className="mt-6 text-xs uppercase tracking-[0.15em] text-gold-glow bg-gold/10 border border-gold/25 rounded-lg px-4 py-3">
                  {settings.notice}
                </p>
              )}

              <div className="mt-auto pt-8 space-y-3">
                <a
                  href={`https://www.google.com/maps/dir/?api=1&destination=${q}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="location-directions-button"
                  className="flex items-center justify-center gap-2 w-full bg-burgundy-brand hover:bg-burgundy-glow text-cream text-xs font-bold uppercase tracking-[0.22em] px-8 py-4 rounded-full border border-gold/30 hover:border-gold/60 transition-all duration-300"
                >
                  <Navigation className="w-4 h-4" /> Come arrivare
                </a>
                {settings?.phone && (
                  <a
                    href={`tel:${settings.phone.replace(/\s/g, "")}`}
                    data-testid="location-call-button"
                    className="flex items-center justify-center gap-2 w-full border border-cream/25 hover:border-gold-glow text-cream hover:text-gold-glow text-xs font-bold uppercase tracking-[0.22em] px-8 py-4 rounded-full transition-colors duration-300"
                  >
                    <Phone className="w-4 h-4" /> {settings.phone}
                  </a>
                )}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
